import { render, staticRenderFns } from "./SettingsShow.vue?vue&type=template&id=57cfc0da&"
import script from "./SettingsShow.vue?vue&type=script&lang=js&"
export * from "./SettingsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports